<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title>
        {{
          feedback.acknowledgedDate
            ? "Feedback Acknowledged"
            : "Let's acknowledge this feedback"
        }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        {{
          feedback.acknowledgedDate
            ? "Great, we've notified the employee for you!"
            : "This will send a confirmation email to the individual"
        }}
      </v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            v-if="!feedback.acknowledgedDate || feedback.responseMessage"
          >
            <v-textarea
              outlined
              v-model="feedback.responseMessage"
              placeholder="Optional - Add a message for the employee*"
              hide-details="auto"
              :disabled="!!feedback.acknowledgedDate"
              auto-grow
            >
            </v-textarea>
            <div class="caption" v-if="!feedback.acknowledgedDate">
              *Employees can't respond to this email and their identity will
              still remain anonymous.
            </div>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
            class="my-auto pr-4"
          >
            <v-btn
              :color="feedback.acknowledgedDate ? 'success' : 'secondary'"
              :loading="saving"
              @click="feedback.acknowledgedDate ? null : save()"
            >
              <v-icon class="pr-2">{{
                feedback.acknowledgedDate ? "check_circle" : "send"
              }}</v-icon>
              {{
                feedback.acknowledgedDate
                  ? "Individual Notified"
                  : "Send Message"
              }}
            </v-btn>
          </v-col>
          <v-col
            v-if="feedback.acknowledgedDate"
            class="lighttext--text subtitle-1 my-auto"
          >
            Sent on {{ feedback.acknowledgedDate | longDate }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PulseFeedbackDialog",
  components: {},
  data: () => ({
    dialog: false,
    saving: false,
    feedback: {},
    feedbackMultiple: []
  }),
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      this.saving = true;
      let list = !this.feedback.id ? [] : [this.feedback];
      list = list.concat(this.feedbackMultiple);
      list.forEach(x => {
        x.responseMessage = this.feedback.responseMessage;
      });
      this.$store
        .dispatch("pulse/acknowledgeFeedback", list)
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Feedback acknowledged");
          this.dialog = false;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while saving your feedback."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    },
    showDialog(feedback, feedbackMultiple) {
      this.dialog = true;
      this.feedback = this._.cloneDeep(feedback || {});
      this.feedbackMultiple = this._.cloneDeep(feedbackMultiple || []);
    }
  }
};
</script>
